module.exports = __webpack_public_path__ + "static/media/gold.dbaac6e8.svg";